import { forEachSchemaNode } from '@framework/validation/describe/forEachSchemaNode.ts';
import { useMemo } from 'react';
import { Schema } from 'yup';

/**
 * Controlla se nella schema è presente almeno un campo con omissis attivo.
 */
export function useCheckSchemaHasActiveOmissis(
  schema: Schema,
  initialValues: any,
  validationContext: any,
): boolean {
  return useMemo(() => {
    let omissis = false;
    forEachSchemaNode(
      schema,
      { value: initialValues, context: validationContext },
      node => {
        if (
          node.schema instanceof Schema &&
          // Se il campo è nascosto, non è presente, quindi non conta come omissis
          !node.schema.spec.strip &&
          node.schema.spec.meta?.hasOmissis
        ) {
          omissis = true;
          return false;
        }
      },
    );
    return omissis;
  }, [schema, validationContext, initialValues]);
}
